import { useEffect } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import ManagerLayout from "@/manager/Layout";
import ManagerLogin from "@/manager/pages/Login";
import Dashboard from "@/manager/pages/Dashboard";
import Agenda from "@/manager/pages/Agenda";
import Events from "@/manager/pages/Events";
import EventDetail from "@/manager/pages/EventDetail";
import Tasks from "@/manager/pages/Tasks";
import Staff from "@/manager/pages/Staff";
import Cleaning from "@/manager/pages/Cleaning";
import Inventory from "@/manager/pages/Inventory";
import Purchases from "@/manager/pages/Purchases";
import Crm from "@/manager/pages/Crm";
import Finance from "@/manager/pages/Finance";
import SettingsPage from "@/manager/pages/Settings";

function Private() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  useEffect(() => { if (!loading && !user) navigate("/manager/login"); }, [user, loading, navigate]);
  useEffect(() => { document.title = "AURA Manager"; }, []);
  if (loading || !user) return <div className="min-h-screen flex items-center justify-center bg-[#F7F5F0]">…</div>;
  return (
    <ManagerLayout>
      <Routes>
        <Route index element={<Dashboard />} />
        <Route path="agenda" element={<Agenda />} />
        <Route path="eventos" element={<Events />} />
        <Route path="eventos/:id" element={<EventDetail />} />
        <Route path="tareas" element={<Tasks />} />
        <Route path="personal" element={<Staff />} />
        <Route path="limpieza" element={<Cleaning />} />
        <Route path="inventario" element={<Inventory />} />
        <Route path="compras" element={<Purchases />} />
        <Route path="crm" element={<Crm />} />
        <Route path="finanzas" element={<Finance />} />
        <Route path="configuracion" element={<SettingsPage />} />
      </Routes>
    </ManagerLayout>
  );
}

export default function ManagerApp() {
  return (
    <Routes>
      <Route path="login" element={<ManagerLogin />} />
      <Route path="*" element={<Private />} />
    </Routes>
  );
}
